/* global App */
import { React } from 'vendor-react';
import InputWrapper from '../InputWrapper';

/* For standalone usage, outside Form Generation, use the StandaloneHoc for the input fields */
class AbstractControlledInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onFieldChange = this.onFieldChange.bind(this);
        this.onFieldBlur = this.onFieldBlur.bind(this);
        this.onOptionsChange = this.onOptionsChange.bind(this);
        this.onFieldFocus = this.onFieldFocus.bind(this);
        this.onPaste = this.onPaste.bind(this);
    }

    onOptionsChange(event) {
        const value = this.props.options[parseInt(event.target.value)].value;
        this.props.onChange(value);
    }

    onFieldChange(event) {
        const value = this.getParsedInputValue(event);
        if (value !== event.target.value) {
            event.target.value = value;
        }
        this.props.onChange && this.props.onChange(value);
    }

    onFieldBlur(event) {
        if (!this.props.onBlur) {
            return;
        }

        const orgValue = event.target.value;
        let value = this.getParsedInputValue(event);
        value = this.transformValue(value);
        // Todo: quirky hack. If user fills in a value that will be the as the prop value AFTER transform
        // the input doesn't renew, because the KEY is the same.
        // e.g. first letter capitilaize:
        // Ana-Banana => Ana-banana
        // Ana-Banana => Ana-Banana in input, Ana-banana in model.
        if (this.props.value !== value || value !== orgValue) {
            event.target.value = value;
        }
        this.props.onBlur(value);
    }

    onFieldFocus(event) {
        this.props.onFocus && this.props.onFocus();
    }

    // Overridden only in the DateInput class
    onPaste(event) {
        if (this.props.disabledPaste) {
            event.preventDefault();
        }
    }

    transformValue(eventValue) {
        let value = eventValue;
        value = App.Utils.Object.trimRemoveDuplicateWhitespace(value);
        const { transformers } = this.props;
        if (App.Utils.Object.isNotEmpty(transformers)) {
            value = transformers.reduce((result, transformer) => transformer(result), value);
        }
        return value;
    }

    getValue(fallbackValue) {
        const { value } = this.props;
        const actualValue = App.Utils.Object.hasValue(value) ? value : fallbackValue || '';
        return this.formatter(actualValue);
    }

    formatter(value) {
        return value;
    }

    getParsedInputValue(event) {
        return event.target.value;
    }

    getInputWrapperProps() {
        const {
            dirty,
            focus,
            label,
            validation,
            onChange,
            onBlur,
            onClear,
            value,
            clearOption,
            required,
            additionalWrapperGroupClass,
            helpText,
        } = this.props;
        return {
            label,
            validation,
            dirty,
            focus,
            onChange,
            onBlur,
            onClear,
            value,
            clearOption,
            required,
            additionalWrapperGroupClass,
            helpText,
        };
    }

    renderInput() {
        throw new Error('Abstract class, implement this method');
    }

    render() {
        return <InputWrapper {...this.getInputWrapperProps()}>{this.renderInput()}</InputWrapper>;
    }
}

export default AbstractControlledInput;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/modules/react-forms/scripts/Components/AbstractInput/index.js